import React, { Suspense } from "react";
import Layout from "./components/Layout";
import Login from "./components/Login";
import Logout from "./components/Logout";

import  Viewer  from './components/Viewer';
import { WebNetConfig } from './components/WebNetConfig';
import  Notifications  from './components/Notifications';
import UserSettings  from './components/UserSettings';

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import UserContext from "./tools/UserContext";
//import PopperJS from "popper.js";

const NotFound = () => "Not found";  // for webpage that not match on the website


function AppRouter() {
  return (
      <UserContext.Consumer>
      {
        ({
            user,
            accesstoken,
            login,
            logout,
            apiCall,
            languageSelected,
            handleLanguageSelected,
            patients,
            selectedPatient,
            localStorageChecked,
            handlePatientSelect,
            availableOpc, 

            animals,
            animalList,
            animalNameList,
            selectedAnimalName,

            selectedAnimal,
            animalInfoOpen,
            handleAnimals,
            handleAnimalSelect,
            handleAnimalSelectByName,
            owners,
            ownersNameList,
            selectedOwner,
            selectedOwnerName,
            handleOwnerSelect,
            handleOwnerSelectByName,

            alertSeverity,
            alertMessage,
            handleMessage,
            searchOpen,
            sessions,
            selectedSession,
            sessionInfoOpen,
            handleSessionSelect,

            sequences,
            selectedSequence,
            handleSequenceSelect,

            handleSearchOpen,

            searchOptionsOpen,
            handleSearchOptions,

            imagesThumbnailBySequences,
            fullImagesInSession,
            selectedImagesThumbnailData,
            thumbnailsData,
            selectedImagesThumbnail,
            handleSelectedImage,
            isExtendedImg,
            handleIsExtendedImg,
            openList,
            handleOpenList,

            colorMapList,
            colorMap,
            fetchColorMaps,
            colorMapSelected,
            handleColorMapSelected,
            colorMapSelectedCode64,
            fetchImage,
            imageSize,

            isFirstSearching,
            isCelcius,
            handleIsCelcius
           

        }) => {
            const spreadMe = {
                logout, apiCall, fetchImage, languageSelected, handleLanguageSelected, patients, selectedPatient, localStorageChecked, handlePatientSelect, availableOpc,
                animals, animalList, animalNameList, selectedAnimal, selectedAnimalName, handleAnimals, handleAnimalSelect, handleAnimalSelectByName, alertSeverity, alertMessage, handleMessage, searchOpen, sessions, selectedSession,
                owners, ownersNameList, selectedOwner, selectedOwnerName, handleOwnerSelect, handleSessionSelect, sequences, selectedSequence, handleSequenceSelect, handleSearchOpen, searchOptionsOpen,
                handleSearchOptions, fullImagesInSession, imagesThumbnailBySequences, thumbnailsData, selectedImagesThumbnail, selectedImagesThumbnailData, handleSelectedImage, isExtendedImg, handleIsExtendedImg, handleOwnerSelectByName, animalInfoOpen, sessionInfoOpen,
                colorMapList, colorMap, colorMapSelected, colorMapSelectedCode64, fetchColorMaps, handleColorMapSelected, imageSize, openList, handleOpenList, isFirstSearching, isCelcius, handleIsCelcius, user };
            
            return accesstoken ? (
                <React.Fragment>
                    <Router>
                        <Suspense fallback={<div>Loading...</div>}>
                            <Switch>
                                <Route path='/' exact component={() => <Layout Component={() => <Viewer {...spreadMe} />} {...spreadMe} />} />
                                <Route path='/viewer' exact component={() => <Layout Component={() => <Viewer {...spreadMe} />} {...spreadMe} />} />
                                <Route path='/usersettings' exact component={() => <Layout Component={() => <UserSettings {...spreadMe} />} {...spreadMe} />} />
                                <Route path='/notifications' exact component={() => <Layout Component={() => <Notifications {...spreadMe} />} {...spreadMe} />} />
                                <Route path='/config' exact component={() => <Layout Component={() => <WebNetConfig {...spreadMe} />} {...spreadMe} />} />
                                <Route path='/' exact component={() => <Layout Component={() => <NotFound />} />}  />
                                <Route path='/logout' exact component={() => <Layout Component={() => <Logout {...spreadMe} />} {...spreadMe} />} />
                                <Route component={() => <Layout Component={() => <NotFound />} logout={logout} />} />
                            </Switch>
                        </Suspense>
                    </Router>
                </React.Fragment>
            ) :
                <Login login={login} />;

        }
      }
    </UserContext.Consumer>
  );
}




export default AppRouter;


/*
 * <Route path="/" exact component={() => <Layout Component={() => <DriveDashboard {...spreadMe} />} {...spreadMe} />} />
<Route path="/data" exact component={() => <Layout Component={() => <DriveDataDashboard {...spreadMe} />} {...spreadMe} />} />
<Route path="/configuration" exact component={() => <Layout Component={() => <DriveConfig {...spreadMe} />} {...spreadMe}/>} />
<Route component={() => <Layout Component={() => <NotFound />} logout={logout} />} />
 
 */